import Layouts from '@/layouts/main-menu/Main'
import { auth } from '@/middleware'
import VueRouterMultiguard from 'vue-router-multiguard'
import securityAccess from '../../../middleware/securityAccess'
export default [
  {
    path: '/capital-state/estados-financieros',
    component: Layouts,
    redirect: { name: 'capital-state.estados-financieros.estados' },
    name: 'capital-state.estados-financieros',
    beforeEnter: VueRouterMultiguard([auth, securityAccess]),
    meta: {
      access: ['capital-state.estados-financieros']
    },
    children: [
      {
        path: '',
        name: 'capital-state.estados-financieros.estados',
        component: () => import('./estados').then(m => m || m),
        meta: {
          activeMenu: 'capital-state.estados-financieros'
        }
      }
    ]
  }
]
